<template>
    <div class="frame_box" id='frame_box' :style="'width:'+ getdocumentarywidth+'px'">
        <div id='dropline_r' @mousedown.stop.prevent="mouseDownRight" class="dropline_r"></div>
        <iframe src="" class="frame" :class="{iframe100:iframebig}" frameborder="0"></iframe>
        <div v-show="iframemaskshow" class="iframemask"></div>
        <!-- http://172.16.4.154/imCustomerTrack/customerDetailPanel?imCustomerId=5dc52e4d4ad9ae000dfd1973&authToken=4762403c3e514e80ba9d8c13819923b0 -->
        <settalk :showaddtalk='showaddtalk' @closeaddtalkfun='closeaddtalkfun'></settalk>

        <!--预览弹窗-->
        <preview-dialog v-if="isPreview" :parentData="previewData" @closePreview="closePreview"></preview-dialog>

        <!-- 评论弹窗 -->
        <comment :commentdata="commentdata" @closecomment="closecomment"></comment>
    </div>

</template>

<script>

    import {
        mapGetters,
        mapMutations
    } from 'vuex'

    import settalk from './settalk'
    import previewDialog from '../../wechatMoments/components/previewDialog.vue'
    import comment from '../../wechatMoments/components/comment.vue'
    export default {
        name: "documentary",
        data() {
            return {
                iframemaskshow: false,
                iframebig: false,
                showaddtalk: false,
                isPreview:false,
                commentdata:{
                    show:false
                }
            }
        },
        components: {
            settalk,
            comment,
            previewDialog
        },
        computed: {
            ...mapGetters('im', [
                'getdocumentarywidth'
            ])
        },
        mounted() {
            if (localStorage.getItem('documentarywidth')) {
                this.SETDOCWIDTH(localStorage.getItem('documentarywidth'))
            }
            let _this = this;
            window.addEventListener('message', function(event) {

                let data = event.data
                if (data.type == 'cancle') {
                    _this.iframebig = false
                }

                if (data.type == 'opendailog') {
                    _this.iframebig = true
                }

                if (data.type == 'showaddtalk') {
                    _this.showaddtalk = true
                }
                if(data.type == "pyq"){
                    _this.isPreview = true
                    _this.previewData = data.data
                }
                if(data.type == 'pyqpl'){
                    _this.commentdata = data.data
                }

            }, false);


        },
        methods: {
            ...mapMutations('im', [
                'SETDOCWIDTH'
            ]),
            closeaddtalkfun() {
                this.showaddtalk = false
            },

            closePreview(){
                this.isPreview = false
            },

            closecomment(){
                this.commentdata.show = false
            },

            messagestate(n) {

                let data = {
                    showchatdailg: n,
                    opentype: 1,
                    data: '数据'
                }
                this.$emit('selectchat', data)
            },
            mouseDownRight(e) {
                let obj = document.getElementById('dropline_r')
                let fobj = document.getElementById('frame_box')
                this.iframemaskshow = true
                e = e || event;
                let dir = '';
                let firstX = e.clientX; //获取第一次点击的横坐标
                let ww = fobj.offsetWidth

                document.onmousemove = (e) => {
                    e = e || event;
                    // return false
                    let neww = e.clientX - firstX;

                    if (ww - neww >= 700 || ww - neww <= 360) {

                        return false
                    }
                    this.SETDOCWIDTH(ww - neww)
                    localStorage.setItem('documentarywidth', ww - neww)
                    // console.log(ww - neww + "px")
                    // obj.style["left"] = this.getlistwidth + "px";
                    // fobj.style["width"] = this.getlistwidth + "px";

                }
                document.onmouseup = () => {
                    document.onmousemove = null;
                    obj.onmousemove = null;
                    this.iframemaskshow = false
                }
                return false;
            }
        },
        destroyed() {
            window.removeEventListener('message', () => {})
        }

    }
</script>

<style lang="less" scoped>
    .frame_box {
        width: 500px;
        position: relative;
        min-width: 360px;
        height: calc(100vh - 50px);
        // z-index: 999;
        background: #fff;

        .frame {
            width: calc(100% - 4px);
            margin-left: 4px;
            height: 100%;
            background: transparent;
            transition: all 0.6;
        }

        .iframe100 {
            position: fixed;
            left: 0;
            top: 60px;
            height: calc(100% - 60px);
        }

        .iframemask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: transparent;
        }

        .btn_documentary {
            width: 76px;
            height: 32px;
            background: #0099ff;
            border-radius: 2px;
            display: block;
            margin: 30px;
            text-align: center;
            line-height: 32px;
            color: #fff;
        }

        .dropline_r {
            position: absolute;
            top: 0;
            left: 0;
            width: 4px;
            cursor: col-resize;
            height: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/documentary.vue